import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';
import Background from '@/assets/icons/cover-images/millionaire-two.png';

const VariationsStyles = createGlobalStyle`
 @font-face {
       font-family: 'CustomArial';
       src: url(${CustomArial});
   }
  
  .generated-images-holder-var24 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var24 {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 1080px;
    justify-content: space-between;
    background: url(${Background}) no-repeat center center;
    background-size: contain;
  }
  .bottom-holder-var24 {
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 235px;
    width: 100%;
  }
  
  .question-var24 {
    line-height: 1.2;
    letter-spacing: 0.05em;
    width: 100%;
    font-size: 48px;
    flex: 1;
    text-align: center;
    color: #fff;
    font-family: CustomArial;
    font-weight: 700;
  }
  
  .top-image-var24 {
    width: 100%;
    height: 790px;
    z-index: -1;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: block;
  }

  .trivia-answer-var24  {
    white-space: nowrap;
    position: absolute;
    font-family: CustomArial;
    font-weight: 700;
    width: 50%;
    font-size: 40px;
    color: #fff;
    letter-spacing: 1.6px;
    display: flex;
    align-items: center;
    height: 60px;
  }
  .answer-a-var24 {
    bottom: 130px;
    left: 88px;
  }
  .answer-b-var24 {
    bottom: 130px;
    left: 610px
  }
  .answer-c-var24 {
    bottom: 34px;
    left: 84px
  }
  .answer-d-var24 {
   bottom: 34px;
   left: 610px
  }
  .trivia-answer-var24 span {
    color: #fac514;
    margin-right: 3px;
  }

  .watermark-var24 {
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 1;
  }
  .actual-photo-var24 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var24--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
